import React from "react"

type ImageProps = {
  url?: string
  alt?: string
  onError: () => void
  className?: string
}

const CustomImage = ({ url, alt, onError, className }: ImageProps) => (
  <img onError={onError} src={url} alt={alt} className={className} />
)

export default CustomImage
